import React, { useEffect, useState } from "react";
import { Gift, Copy, Check, Share2 } from "lucide-react";
import { toast } from "sonner";
import { apiFetch } from "@/lib/api";

export default function ReferralCard() {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    apiFetch("/referral/me").then(setData).catch(() => {});
  }, []);

  if (!data) return null;

  const link = `${window.location.origin}/signup?ref=${data.code}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      toast.success("Invite link copied!");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Couldn't copy — long-press to copy the link.");
    }
  };

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Wooflect",
          text: `Join me on Wooflect — we both get ${data.reward_days} days of Pro free! 🐶`,
          url: link,
        });
      } catch {
        /* user cancelled */
      }
    } else {
      copy();
    }
  };

  return (
    <div className="p-5 rounded-3xl bg-[#E8F0E5] mb-5" data-testid="referral-card">
      <div className="flex items-center gap-2 mb-1">
        <Gift size={20} color="#6F8F72" />
        <p className="font-display text-lg font-extrabold">Invite friends, both get Pro</p>
      </div>
      <p className="text-sm text-[#4A4746]">
        Share your link — when a friend joins, you <b>both</b> get {data.reward_days} days of Wooflect Pro free.
        {data.referrals_count > 0 && ` You've referred ${data.referrals_count} so far! 🎉`}
      </p>

      <div className="flex items-center gap-2 mt-4 bg-white rounded-2xl border border-[#cfe0c9] p-2">
        <span data-testid="referral-link" className="flex-1 min-w-0 truncate text-sm text-[#4A4746] pl-2">{link}</span>
        <button
          data-testid="referral-copy-btn"
          onClick={copy}
          className="h-9 w-9 rounded-xl bg-[#F2EFE9] flex items-center justify-center hover:bg-[#E8E3DA] shrink-0"
          aria-label="Copy invite link"
        >
          {copied ? <Check size={17} color="#6F8F72" /> : <Copy size={17} color="#4A4746" />}
        </button>
      </div>

      <button
        data-testid="referral-share-btn"
        onClick={share}
        className="w-full mt-3 flex items-center justify-center gap-2 rounded-full bg-[#6F8F72] text-white font-extrabold py-2.5 hover:brightness-105 transition-all"
      >
        <Share2 size={17} /> Share invite
      </button>
    </div>
  );
}
